import { createActions, createReducer } from 'reduxsauce'

import CargoService from '../servicos/CargoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaCargoInicio: [],
    buscaCargoSucesso: ['cargo'],
    buscaCargoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaCargo = () => {
    return dispatch => {
        dispatch(Creators.buscaCargoInicio())
        let serv = new CargoService()
        return serv
            .consultar()
            .then(response => dispatch(Creators.buscaCargoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaCargoErro(error)))
    }
}

const buscaCargoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaCargoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaCargoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.cargo, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CARGO_INICIO]: buscaCargoInicio,
    [Types.BUSCA_CARGO_ERRO]: buscaCargoErro,
    [Types.BUSCA_CARGO_SUCESSO]: buscaCargoSucesso,
})
